import { estadoUsuario } from "@pcgerente-node/pcg-comun";
import { USUARIO } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { PayloadAction } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { RolesUsuarios } from "../../components/useAuth/useAuth";
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import { USUARIOviewModel } from "../../ViewModels/USUARIOviewModel";
import { baseURL, handleResponse, headers } from "../helpersRedux";
import { setUsuarioActual } from "../slices/authSlice";

//Usuario 
/**Intenta buscar el usuario en el login si no lo encuentra tira un error */
export const buscarUsuarioPorCredenciales = async(usuario: string, password: string ) =>{
    const body= {usuario, password}
    const response = await axios.post(`${baseURL}USUARIO/login`,body,headers)
      .then((res: AxiosResponse<IApiResponse<USUARIO>>) => handleResponse(res))
      if(response.id>0){
        guardarIdUsuarioEnLocalStorage(response.id)
      }
    return response
};

export const buscarUsuarioPorId = (idUsuario?: number) => 
    async (dispatch:(action: PayloadAction<USUARIOviewModel>) => void) => {
  try{
    if(!idUsuario){
      const idUsuarioLocalStorage = localStorage.getItem('idUsuario')
      const id = JSON.parse(idUsuarioLocalStorage??"")
      if(id && !isNaN(Number(id))){
        idUsuario = Number(id)
      }
    }
      const usuarioDB = await ObtenerUsuarioPorId(idUsuario??0)
      guardarUsuarioEnRedux(usuarioDB)
  }catch(error){
    if(error instanceof Error){
      const retorno = new USUARIOviewModel()
      retorno.error = error.message
      dispatch(setUsuarioActual(retorno))
    }
  }
};
export const guardarUsuarioEnRedux = (usuario: USUARIO) => 
    (dispatch:(action: PayloadAction<USUARIOviewModel>) => void) => {
    const retorno = new USUARIOviewModel
    if(usuario.estado === estadoUsuario.Pendiente){
      retorno.requiereCambiarContrasenia = true
    }else{
      if(usuario.idConductor && usuario.idConductor>0 && usuario.habilitado){
        retorno.rolUsuario = RolesUsuarios.CONDUCTOR
      }
      else if(usuario.id >0){
        // retorno.rolUsuario = RolesUsuarios.COMUN
        retorno.rolUsuario = RolesUsuarios.COMUN
      }else{
        retorno.rolUsuario = RolesUsuarios.INVITADO
      }
      retorno.autenticado = true
    }
    retorno.loading = false
    retorno.setItemActivo(usuario)
    guardarIdUsuarioEnLocalStorage(usuario.id)
    dispatch(setUsuarioActual(retorno))
}


export const limpiarAuthSlice =() => 
    (dispatch:(action: PayloadAction<USUARIOviewModel>) => void) => {
    borrarLocalStorage()
    dispatch(setUsuarioActual(new USUARIOviewModel()))
};

export async function ObtenerUsuarioPorId(idUsuario: number): Promise<USUARIO>{
  const retorno = await axios.get(`${baseURL}USUARIO/${idUsuario}`, headers)
    .then((res: AxiosResponse<IApiResponse<USUARIO>>) => handleResponse(res))
    return retorno
}

const guardarIdUsuarioEnLocalStorage= (idUsuario: number) => { 
    const dataJson = JSON.stringify(idUsuario);
    localStorage.setItem('idUsuario', dataJson);
};

const borrarLocalStorage = () => {
    localStorage.removeItem('idUsuario')
}